import $ from 'jquery'
import Modernizr from 'modernizr'

SOPHIA.stickyHeaderForTable = function() {
  var windowWidth = $(window).width();

  if (windowWidth > 600) {
    $('.table-container').stickyTableHeader();

    if ($('.sticky-container').length) {
      $('body').addClass('mag-sticky-nav');
    }
  }

  $(window).on('resize', function() {
    if (windowWidth > 600) {
      var instance = $('.table-container').data('stickyTableHeader');
      if (instance) {
        instance.destroy();
      }
      $('.table-container').stickyTableHeader();
    }
  });

  if (Modernizr.touchevents) {
    $(window).on('orientationchange', function() {
      if (windowWidth > 600) {
        $('.table-container').stickyTableHeader();

        if ($('.sticky-container').length) {
          $('body').addClass('mag-sticky-nav');
        }
      }
    });
  }
};
